export interface IFilter {
  $fa: boolean;

  fill(data: any);

  get();

  refresh(params: object);
}
